import React from "react";
import Grid from "../../GridCards/Grid";
const Caja = () => {
  return <Grid />;
};

export default Caja;
